// 使用环境变量配置API URL，默认为生产环境
const API_URL = process.env.REACT_APP_API_URL || 'https://sub.ouvg.top';

export async function checkSubscription(email) {
  try {
    const response = await fetch(`${API_URL}/check-subscription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('网络响应不正常');
    }

    return response.json();
  } catch (error) {
    console.error('Error checking subscription:', error);
    throw error;
  }
}

export async function getAnnouncement() {
  try {
    const response = await fetch(`${API_URL}/api/announcement`);
    if (!response.ok) {
      throw new Error('获取公告失败');
    }
    return response.json();
  } catch (error) {
    console.error('Error getting announcement:', error);
    throw error;
  }
}

// 管理员API函数
export async function getAllSubscriptions() {
  try {
    const response = await fetch(`${API_URL}/api/admin/subscriptions`);
    if (!response.ok) {
      throw new Error('获取订阅列表失败');
    }
    return response.json();
  } catch (error) {
    console.error('Error getting subscriptions:', error);
    throw error;
  }
}

export async function addSubscription(subscriptionData) {
  try {
    const response = await fetch(`${API_URL}/api/admin/subscriptions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(subscriptionData),
    });

    if (!response.ok) {
      throw new Error('添加订阅失败');
    }

    return response.json();
  } catch (error) {
    console.error('Error adding subscription:', error);
    throw error;
  }
}

export async function updateSubscription(email, updates) {
  try {
    const response = await fetch(`${API_URL}/api/admin/subscriptions/${email}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updates),
    });

    if (!response.ok) {
      throw new Error('更新订阅失败');
    }

    return response.json();
  } catch (error) {
    console.error('Error updating subscription:', error);
    throw error;
  }
}

export async function deleteSubscription(email) {
  try {
    const response = await fetch(`${API_URL}/api/admin/subscriptions/${email}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('删除订阅失败');
    }

    return response.json();
  } catch (error) {
    console.error('Error deleting subscription:', error);
    throw error;
  }
}

